import AvatarIcon from './AvatarIcon';

export default AvatarIcon;
